import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import ProspectusLink from '@prospectus/common/ui-strict/ProspectusLink';

const messages = defineMessages({
  'prospectus.course.business.purchase': {
    id: 'prospectus.course.business.purchase',
    description: 'Link for business purchase of this course',
    defaultMessage: 'Purchase now',
  },
});

function BasePurchaseBtn({
  intl, businessSeatUrl, isArchived, className, onClick,
}) {
  return (
    <ProspectusLink
      href={isArchived ? 'https://business.edx.org/?lead_source=edX+Course+Page&utm_campaign=B2B+Container&utm_source=Referral' : businessSeatUrl}
      className={className}
      analytics={{
        eventName: 'edx.bi.user.b2b.purchase.click',
      }}
      onClick={onClick}
    >
      {intl.formatMessage(messages['prospectus.course.business.purchase'])}
    </ProspectusLink>
  );
}

BasePurchaseBtn.propTypes = {
  intl: intlShape.isRequired,
  isArchived: PropTypes.bool.isRequired,
  businessSeatUrl: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

BasePurchaseBtn.defaultProps = {
  onClick: () => {},
};

export default injectIntl(BasePurchaseBtn);
